import { render, staticRenderFns } from "./ChangePhoneNew.vue?vue&type=template&id=bb80e9a4&"
import script from "./ChangePhoneNew.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports